import { render, staticRenderFns } from "./monthSalesVolumes.vue?vue&type=template&id=600bfe97&scoped=true&"
import script from "./monthSalesVolumes.vue?vue&type=script&lang=js&"
export * from "./monthSalesVolumes.vue?vue&type=script&lang=js&"
import style0 from "./monthSalesVolumes.vue?vue&type=style&index=0&id=600bfe97&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600bfe97",
  null
  
)

export default component.exports